/* ==========================================================================
   PROPUESTA 1 · «LA SALA» — Cuadros Splash (24 sep 2026)

   1. En el móvil, la barrita de progreso bajo las fotos: dice dónde estás y
      cada tramo lleva a su foto.
   2. El visor a pantalla completa: flechas, teclado, deslizar con el dedo y
      un toque para acercarse (se recorre moviendo el ratón o el dedo).
   3. La lupa de la obra, con ratón.
   4. El probador «Cuélgalo en tu casa» de debajo del 3D: carga sus guiones
      cuando se acerca a la pantalla y se va detrás de la ficha en el móvil.
      Con foto, se sigue en la página del probador (lo hace cs-salon.js).
   5. La frase «Mira cómo queda en tu …» del probador: la estancia cambia
      sola cada 2,4 s mientras se ve (y se para si no se ve).

   Las fotos no pasan solas: el único reloj es el de la frase (5). Ver
   snippets/cs-galeria-sala.liquid.
   ========================================================================== */
(function () {
  'use strict';
  if (!window.customElements || customElements.get('cs-galeria-sala')) return;

  var CON_RATON = window.matchMedia('(hover: hover) and (pointer: fine)');
  var MOVIL = window.matchMedia('(max-width: 749px)');

  class GaleriaSala extends HTMLElement {
    connectedCallback() {
      if (this._listo) return;
      this._listo = true;
      this.muro = this.querySelector('[data-sala-muro]');
      this.armarProgreso();
      this.armarVisor();
      this.armarLupa();
      this.armarProbador();
      this.armarFrase();
    }

    /* ---------- 1. La barrita del móvil ---------- */
    armarProgreso() {
      var muro = this.muro;
      var tramos = this.querySelector('[data-sala-tramos]');
      var cuenta = this.querySelector('[data-sala-cuenta]');
      if (!muro || !tramos || !cuenta) return;

      function piezas() {
        return muro.querySelectorAll('[data-sala-pieza]');
      }
      function actual() {
        var ancho = muro.clientWidth || 1;
        return Math.round(muro.scrollLeft / ancho);
      }
      function marcar() {
        var total = piezas().length;
        var a = Math.max(0, Math.min(actual(), total - 1));
        tramos.querySelectorAll('button').forEach(function (b, i) {
          b.classList.toggle('is-activo', i === a);
          b.setAttribute('aria-current', i === a ? 'true' : 'false');
        });
        cuenta.textContent = (a + 1) + ' / ' + total;
      }
      function ir(i) {
        muro.scrollTo({ left: i * muro.clientWidth, behavior: 'smooth' });
      }
      function pintar() {
        tramos.textContent = '';
        piezas().forEach(function (_, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'cs-muro__tramo';
          b.setAttribute('aria-label', 'Ir a la foto ' + (i + 1));
          b.addEventListener('click', function () { ir(i); });
          tramos.appendChild(b);
        });
        marcar();
      }

      var pendiente = false;
      muro.addEventListener('scroll', function () {
        if (pendiente) return;
        pendiente = true;
        requestAnimationFrame(function () {
          pendiente = false;
          marcar();
        });
      }, { passive: true });
      muro.addEventListener('scrollend', marcar);

      /* Si el 3D no llega a montarse, cs-lienzo-galeria.js quita su pieza:
         la barrita tiene que enterarse y quedarse con un tramo menos. */
      new MutationObserver(pintar).observe(muro, { childList: true });
      pintar();
    }

    /* ---------- 2. El visor a pantalla completa ---------- */
    armarVisor() {
      var v = this.querySelector('[data-sala-visor]');
      if (!v) return;
      var fotos = Array.prototype.slice.call(v.querySelectorAll('[data-visor-foto]'));
      var minis = Array.prototype.slice.call(v.querySelectorAll('[data-visor-ir]'));
      var cuenta = v.querySelector('[data-visor-cuenta]');
      var zona = v.querySelector('[data-visor-fotos]');
      var n = fotos.length;
      var actual = 0;
      var abierto = false;
      if (!n) return;
      if (n === 1) v.classList.add('cs-murovisor--una');

      function cargar(i) {
        var img = fotos[(i + n) % n].querySelector('img');
        if (img && !img.getAttribute('src') && img.dataset.src) img.src = img.dataset.src;
      }
      function alejar() {
        fotos.forEach(function (f) { f.classList.remove('is-cerca'); });
      }
      function mostrar(i) {
        actual = (i + n) % n;
        alejar();
        fotos.forEach(function (f, k) {
          f.classList.toggle('is-activa', k === actual);
          f.setAttribute('aria-hidden', k === actual ? 'false' : 'true');
        });
        minis.forEach(function (m, k) {
          m.setAttribute('aria-current', k === actual ? 'true' : 'false');
        });
        cuenta.textContent = (actual + 1) + ' / ' + n;
        cargar(actual);
        cargar(actual + 1);
        cargar(actual - 1);
      }
      function abrir(i) {
        if (!abierto) {
          abierto = true;
          document.documentElement.classList.add('cs-murovisor-abierto');
          if (typeof v.showModal === 'function') v.showModal();
          else v.setAttribute('open', '');
        }
        mostrar(i);
      }
      /* La limpieza va por tres caminos (botón, Escape y el evento close) y
         da igual cuántas veces se llame: hay navegadores que no disparan
         alguno de ellos. */
      function limpiar() {
        if (!abierto) return;
        abierto = false;
        alejar();
        document.documentElement.classList.remove('cs-murovisor-abierto');
      }
      function cerrar() {
        limpiar();
        if (v.open) {
          try { v.close(); } catch (e) { v.removeAttribute('open'); }
        } else {
          v.removeAttribute('open');
        }
      }

      this.addEventListener('click', function (e) {
        var b = e.target.closest('[data-abrir]');
        if (b) abrir(parseInt(b.dataset.abrir, 10) || 0);
      });

      v.addEventListener('close', limpiar);
      v.addEventListener('cancel', function (e) {
        e.preventDefault();
        cerrar();
      });
      v.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.preventDefault(); cerrar(); }
        else if (e.key === 'ArrowRight') mostrar(actual + 1);
        else if (e.key === 'ArrowLeft') mostrar(actual - 1);
      });
      v.querySelector('[data-visor-cerrar]').addEventListener('click', cerrar);
      v.querySelector('[data-visor-ant]').addEventListener('click', function () { mostrar(actual - 1); });
      v.querySelector('[data-visor-sig]').addEventListener('click', function () { mostrar(actual + 1); });
      minis.forEach(function (m) {
        m.addEventListener('click', function () { mostrar(parseInt(m.dataset.visorIr, 10) || 0); });
      });

      /* Acercarse: el punto de la foto bajo el puntero es el que se amplía.
         Se mide contra la caja SIN transformar (offsetLeft/offsetWidth), no
         contra getBoundingClientRect, que ya vendría ampliada. */
      function enfocar(f, e) {
        var img = f.querySelector('img');
        var caja = f.getBoundingClientRect();
        var x = (e.clientX - caja.left - img.offsetLeft) / (img.offsetWidth || 1);
        var y = (e.clientY - caja.top - img.offsetTop) / (img.offsetHeight || 1);
        x = Math.min(Math.max(x, 0), 1);
        y = Math.min(Math.max(y, 0), 1);
        img.style.transformOrigin = (x * 100) + '% ' + (y * 100) + '%';
      }

      var x0 = null;
      var y0 = null;
      var movido = false;
      zona.addEventListener('pointerdown', function (e) {
        x0 = e.clientX;
        y0 = e.clientY;
        movido = false;
      });
      zona.addEventListener('pointermove', function (e) {
        var f = fotos[actual];
        if (x0 !== null && Math.abs(e.clientX - x0) + Math.abs(e.clientY - y0) > 10) movido = true;
        if (f.classList.contains('is-cerca')) enfocar(f, e);
      });
      zona.addEventListener('pointerup', function (e) {
        if (x0 === null) return;
        var dx = e.clientX - x0;
        var dy = e.clientY - y0;
        x0 = null;
        var f = fotos[actual];
        var cerca = f.classList.contains('is-cerca');
        // Deslizar pasa de foto, salvo si estás acercado: ahí el dedo recorre.
        if (!cerca && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
          mostrar(actual + (dx < 0 ? 1 : -1));
          return;
        }
        if (movido || e.target.tagName !== 'IMG') return;
        if (cerca) {
          f.classList.remove('is-cerca');
        } else {
          enfocar(f, e);
          f.classList.add('is-cerca');
        }
      });
      zona.addEventListener('pointercancel', function () { x0 = null; });
    }

    /* ---------- 3. La lupa de la obra ----------
       Solo con ratón: con el dedo, tocar abre la pantalla completa, que ya
       acerca. La foto grande no se pide hasta que el ratón entra. */
    armarLupa() {
      var pared = this.querySelector('.cs-muro__pared');
      var lupa = pared && pared.querySelector('[data-muro-lupa]');
      var img = pared && pared.querySelector('img');
      if (!lupa || !img) return;

      var cargada = false;
      function cargar() {
        if (cargada) return;
        cargada = true;
        lupa.style.backgroundImage = 'url("' + lupa.dataset.src + '")';
      }

      pared.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse' || !CON_RATON.matches) return;
        cargar();
        var rp = pared.getBoundingClientRect();
        var ri = img.getBoundingClientRect();
        var x = e.clientX - ri.left;
        var y = e.clientY - ri.top;
        if (x < 0 || y < 0 || x > ri.width || y > ri.height) {
          lupa.classList.remove('is-visible');
          return;
        }
        var d = lupa.offsetWidth;
        /* El aumento que pone la obra a la resolución de la foto grande,
           entre 2 y 3 veces: que siempre se note y nunca se pixele. */
        var z = Math.max(2, Math.min(3, (parseFloat(lupa.dataset.ancho) || 2048) / ri.width));
        lupa.style.backgroundSize = (ri.width * z) + 'px ' + (ri.height * z) + 'px';
        lupa.style.backgroundPosition = (d / 2 - x * z) + 'px ' + (d / 2 - y * z) + 'px';
        lupa.style.left = (e.clientX - rp.left - d / 2) + 'px';
        lupa.style.top = (e.clientY - rp.top - d / 2) + 'px';
        lupa.classList.add('is-visible');
      });
      pared.addEventListener('pointerleave', function () {
        lupa.classList.remove('is-visible');
      });
      // Al abrir la pantalla completa la lupa se queda atrás: que no espere.
      pared.addEventListener('click', function () {
        lupa.classList.remove('is-visible');
      });
    }

    /* ---------- 4. El probador «Cuélgalo en tu casa» ---------- */
    armarProbador() {
      var caja = this.querySelector('[data-muro-probador]');
      if (!caja) return;

      /* LOS GUIONES, CUANDO HACEN FALTA. No se cargan con la ficha, sino
         cuando el probador está a punto de verse o alguien lo toca.
         async = false los ejecuta en el orden de la lista (Mi casa, flujo),
         que es el que necesitan. El motor WebGL ya no viene: desde el 24 sep
         2026 la foto se sigue en la página del probador. */
      var cargado = false;
      function cargar() {
        if (cargado) return;
        cargado = true;
        var lista = (caja.dataset.guiones || '').split(' ').filter(Boolean);
        lista.forEach(function (src, i) {
          if (document.querySelector('script[src="' + src + '"]')) return;
          var s = document.createElement('script');
          s.src = src;
          s.async = false;
          if (i === lista.length - 1) {
            /* Si alguien eligió la foto antes de que llegara el guion, se le
               entrega ahora: si no, ese primer intento se perdería. */
            s.onload = function () {
              var archivo = caja.querySelector('[data-cs-salon-archivo]');
              if (archivo && archivo.files && archivo.files.length) {
                archivo.dispatchEvent(new Event('change', { bubbles: true }));
              }
            };
          }
          document.head.appendChild(s);
        });
      }
      /* El vigía se pone cuando la página ha terminado de cargar: antes, con
         las hojas de estilo aún llegando, la galería mide poco y el
         probador parece estar a la vista aunque quede muy abajo. */
      function vigilar() {
        if (!('IntersectionObserver' in window)) return cargar();
        var ojo = new IntersectionObserver(function (entradas) {
          if (!entradas[0].isIntersecting) return;
          ojo.disconnect();
          cargar();
        }, { rootMargin: '600px 0px' });
        ojo.observe(caja);
      }
      if (document.readyState === 'complete') vigilar();
      else window.addEventListener('load', vigilar, { once: true });
      caja.addEventListener('pointerdown', cargar);
      caja.addEventListener('focusin', cargar);

      /* EN EL MÓVIL, DETRÁS DE LA FICHA. Mover el nodo no rompe nada: el
         guion del probador guarda referencias a sus elementos, no rutas. */
      var producto = this.closest('.product');
      var sitio = caja.parentNode;
      var siguiente = caja.nextSibling;
      function colocar() {
        if (!producto) return;
        if (MOVIL.matches) {
          if (producto.nextSibling !== caja) producto.after(caja);
          caja.classList.add('cs-muro__probador--suelto');
        } else if (caja.parentNode !== sitio) {
          sitio.insertBefore(caja, siguiente);
          caja.classList.remove('cs-muro__probador--suelto');
        }
      }
      colocar();
      if (MOVIL.addEventListener) MOVIL.addEventListener('change', colocar);
    }
    /* ---------- 5. La frase que cambia de estancia ----------
       La palabra que sale sube y se apaga; la que entra sube desde abajo, y
       el trazo de ocre se pinta detrás de ella de izquierda a derecha. El
       hueco cambia de ancho a la vez, así el resto de la frase se aparta sin
       saltos. Solo corre mientras la frase se ve y la pestaña está delante;
       con «reducir movimiento» se queda quieta en «salón». */
    armarFrase() {
      var frase = this.querySelector('[data-cs-frase]');
      if (!frase) return;
      var hueco = frase.querySelector('[data-cs-frase-hueco]');
      var molde = frase.querySelector('[data-cs-frase-molde]');
      var palabras = (frase.dataset.palabras || '').split('|').filter(Boolean);
      if (!hueco || !molde || palabras.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var i = 0;
      var visible = !('IntersectionObserver' in window);

      function paso() {
        i = (i + 1) % palabras.length;
        var sale = hueco.querySelector('.cs-salon__frase-palabra:not(.is-arriba)');

        // El ancho nuevo: se mide con el molde y se anima desde el de ahora.
        var antes = hueco.getBoundingClientRect().width;
        molde.textContent = palabras[i];
        hueco.style.width = '';
        var despues = hueco.getBoundingClientRect().width;
        hueco.style.width = antes + 'px';
        void hueco.offsetWidth;
        hueco.style.width = despues + 'px';

        var entra = document.createElement('span');
        entra.className = 'cs-salon__frase-palabra is-abajo';
        entra.textContent = palabras[i];
        hueco.appendChild(entra);
        void entra.offsetWidth;
        entra.classList.remove('is-abajo');

        if (sale) {
          sale.classList.add('is-arriba');
          setTimeout(function () { sale.remove(); }, 700);
        }
      }

      setInterval(function () {
        if (visible && !document.hidden) paso();
      }, 2400);
      if (!visible) {
        new IntersectionObserver(function (entradas) {
          visible = entradas[0].isIntersecting;
        }).observe(frase);
      }
      // Para probarla a mano desde la consola, sin esperar al reloj.
      frase.csSiguiente = paso;
    }
  }

  customElements.define('cs-galeria-sala', GaleriaSala);
})();
